<template>
  <v-card class="ts-manage">
    <v-card-title class="ts-manage__header light-green lighten-2">
      Manage record
    </v-card-title>
    <v-container class="ts-manage__body">
      <v-row>
        <v-col cols="auto">
          <v-btn @click="fromTeam">Team페이지 데이터 불러오기</v-btn>
          <v-btn @click="toJson">ToJSON</v-btn>
          <v-btn @click="handleClickGetAllRecords">GetAllRecords</v-btn>
        </v-col>
      </v-row>
      <ts-record-maker
          :text="text"
          :players="players"
          :records.sync="data"
          @parse="handleParse"
      ></ts-record-maker>
      <ts-record-table
          ref="recordTable"
          hide-title
          winner-always-left
          :players="players"
          :records.sync="data"
      ></ts-record-table>
    </v-container>
    <v-card-actions class="ts-manage__footer">
      <v-spacer></v-spacer>
      <v-btn
          text
          @click="handleClickSave()"
      >Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped lang="scss">
.ts-manage {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &__reset-mode {
    margin-top: 0;
  }

  &__header {
    flex-grow: 0;
  }

  &__body {
    flex-grow: 1;
    overflow-y: auto;
  }

  &__footer {
    flex-grow: 0;
  }
}
</style>

<script>
import {getRecords, pushRecords} from "../api/record";
import TsRecordTable from "@/components/TsRecordTable";
import {getPlayers} from "@/api/player";
import TsRecordMaker from "@/components/TsRecordMaker";
import {getGameInstance} from "@/api/instance";

export default {
  name: "Manage",
  components: {TsRecordMaker, TsRecordTable},
  props: ['record'],
  data() {
    return {
      resetMode: false,
      selectedTab: 0,
      data: this.record || [],
      error: [],
      players: [],
      text: '',
    }
  },
  watch: {
    record(val) {
      this.data = val
    }
  },
  async created() {
    this.players = await getPlayers()
  },
  methods: {
    fromTeam() {
      getGameInstance().then(data => {
        this.data = (data.teamingResults || []).filter(r => r.date)
      })
    },
    toJson() {
      this.data.forEach(data => data.players = [...new Set([...data.winners, ...data.losers])])
      this.text = JSON.stringify(this.data)
      this.text = this.text.replace(/\},/g, '},\n').replace(/\[\{/g, '[\n{').replace(/\}\]/g,
          '}\n]')
    },
    handleClickGetAllRecords() {
      return getRecords().then((data) => {
        this.data = data
      })
    },
    async handleClickSave() {
      if (!this.data.length) {
        return this.$alert('No contents')
      }
      if (this.error.length && !await this.$confirm('에러메시지가 있습니다. 정말 저장합니까?')) {
        return
      }
      if (!await this.$confirm(`${this.data.length}개 의 새로운 데이터를 푸시합니다`)) {
        return
      }
      const records = this.data.map(r => ({players: [...r.winners, ...r.losers], ...r}))
      return pushRecords(records).then(
          (result) => {
            this.$emit('click:save')
            if (result.map(({data}) => data.err).find(err => err)) {
              this.$alert('로그를 확인하세요', '오류', 'danger')
            } else {
              this.$alert('성공')
              this.data = []
              return records
            }
            return false
          })
    },
    handleParse(data, error) {
      this.error = error
    }
  }
}
</script>